import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import {
  MB_PRODUCT_TAB_EXTENDED_VALIDATION_NORMALIZER,
  MbProductTabExtendedValidationAdapter
} from '../connectors/extended-validation'

@Injectable({
  providedIn: 'root'
})
export class MbOccProductTabExtendedValidationAdapter implements MbProductTabExtendedValidationAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  load (productCode: string) {
    return this.http.get(this.getEndpoint(productCode)).pipe(
      this.converter.pipeable(MB_PRODUCT_TAB_EXTENDED_VALIDATION_NORMALIZER)
    )
  }

  protected getEndpoint (code: string) {
    return this.occEndpoints.buildUrl(
      'productTabExtendedValidation',
      {
        urlParams: { productCode: code },
      }
    )
  }
}
